import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenesysSparkWrapperService } from '../genesys-spark-wrapper.service';

export enum CONFIRM_DIALOG_MODE {
  OK = 0,
  YES_NO = 1,
  SAVE_CANCEL = 2,
  DELETE_CANCEL = 3,
  DISCARD_CANCEL = 4
}

export interface ConfirmationDialogData {
  title: string;
  message: string;
  messageArray: string[];
  messageCentered: boolean;
  mode: CONFIRM_DIALOG_MODE;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['../admission-ui.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  ConfirmDialogMode: any = CONFIRM_DIALOG_MODE; // This is so we can use the ENUM in the HTML template

  isLoading: boolean = false;

  constructor(
    private readonly sparkService: GenesysSparkWrapperService,
    private readonly dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) { }

  ngOnInit() {
    this.sparkService.register().then(() => {
      this.isLoading = false;
    });
  }

  closeDialog(confirm: boolean): void {
    this.dialogRef.close(confirm);
  }

}
